import Handlebars from '@sparta.global.vendors/handlebars';
import '@sparta.global.vendors/jsencrypt';
import ahWebbioUtility from '@sparta.authglobal.utilities/ah-webbio-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import ahCommonUtility from '@sparta.authglobal.utilities/ah-common-utility/dist/es6.js';
import AhPwdlessCommonsUtility from '@sparta.authglobal.utilities/ah-pwdless-common-utility/dist/es6.js';
import ahTransportUtility from '@sparta.authglobal.utilities/ah-transport-utility/dist/es6.js';
import { passwordInput, textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { checkbox } from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import { layerContent, link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import signInFpUtility from '@sparta.global.utilities/signin-fp-utility/dist/es6.js';

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"infoLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"outageContent") : stack1),"==","sign-in-enabled-content",{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":25,"column":16},"end":{"line":52,"column":28}}})) != null ? stack1 : "")
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"lookDifferentModalLayerContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":20},"end":{"line":28,"column":37}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"lookDifferentModalLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <style type=\"text/css\">\r\n                        .manage-mobile-banking {\r\n                            background-image: url("
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link1Icon") : stack1), depth0)) != null ? stack1 : "")
    + ");\r\n                        }\r\n\r\n                        .manage-find-center {\r\n                            background-image: url("
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link2Icon") : stack1), depth0)) != null ? stack1 : "")
    + ");\r\n                        }\r\n\r\n                        .manage-contact-us {\r\n                            background-image: url("
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link3Icon") : stack1), depth0)) != null ? stack1 : "")
    + ");\r\n                        }\r\n                    </style>\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":20},"end":{"line":51,"column":37}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p>\r\n                            "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                            "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link2") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                            "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"link3") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                        </p>\r\n\r\n                        "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"manageFinanceLayerContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n\r\n<div class=\"row vertical horizontal show-for-medium-up collapse\" id=\"skip-to-h1\">\r\n    <div id=\"globalInputsValidationForm\" class=\"column small-12 end sign-in\">\r\n        <form id=\"signinClient\" novalidate autocomplete=\"off\" onsubmit=\"window.signInSubmitted = true;return false;\"\r\n            method=\"POST\" tabindex=\"-1\">\r\n            <div id=\"signInPartialContent\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"vertical"),depth0,{"name":"vertical","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "            </div>\r\n            <span class=\"ada-hidden form-end show-for-medium-only\" tabindex=\"0\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"menuEndAdaText") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||alias3).call(alias2,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"infoLayerContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":21,"column":29}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"disableSignin") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":12},"end":{"line":54,"column":19}}})) != null ? stack1 : "")
    + "        </form>\r\n        <script type=\"text/javascript\">\r\n        document.getElementById('"
    + alias4(alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdField") : stack1)) != null ? lookupProperty(stack1,"input") : stack1)) != null ? lookupProperty(stack1,"attrs") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "').value = '';\r\n        </script>\r\n    </div>\r\n    <form id=\"signinInfo\" action=\""
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"submitAction") : stack1), depth0)) != null ? stack1 : "")
    + "\" method=\"POST\">\r\n        \r\n        <input type=\"hidden\" id=\"f_variable\" name=\"f_variable\" value=\"\">\r\n        <input type=\"hidden\" id=\"locale\" name=\"locale\" value=\"\" />\r\n        <input type=\"hidden\" id=\"anotherOnlineIDFlag\" name=\"anotherOnlineIDFlag\" value=\"\" />\r\n        <input type=\"hidden\" id=\"dltoken\" name=\"dltoken\" value=\"\">\r\n        <input type=\"hidden\" id=\"Access_ID_1\" name=\"Access_ID_1\" value=\"\">\r\n        <input type=\"hidden\" id=\"reason\" name=\"reason\" value=\"\">\r\n        <input type=\"hidden\" id=\"passcode\" name=\"passcode\" value=\"\">\r\n        <input type=\"hidden\" id=\"onlineId\" name=\"onlineId\" value=\"\">\r\n        <input type=\"hidden\" id=\"multiID\" name=\"multiID\" value=\"\">\r\n        <input type=\"hidden\" id=\"saveMyID\" name=\"saveMyID\" value=\"\">\r\n        <input type=\"hidden\" id=\"webAuthAPI\" name=\"webAuthAPI\" value=\"\">\r\n        <input type=\"hidden\" id=\"origin\" name=\"origin\" value=\"sparta_homepage\">\r\n    </form>\r\n<div class=\"row open-account-link\">\r\n        <div class=\"medium-12 column\">\r\n            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias3).call(alias2,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"open") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":81,"column":12},"end":{"line":81,"column":39}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"signin-jcr\" data-jcr=\""
    + alias4((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias3).call(alias2,(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":85,"column":31},"end":{"line":85,"column":45}}}))
    + "\"></div>";
},"usePartial":true,"useData":true});
const renderTemplate$2 = function (data, options) {
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\" id=\"skip_to_signin\">\r\n    <div class=\"medium-12 column\" id=\"signin-message\"></div>\r\n    <div class=\"medium-5 column hidden\" id=\"dropDown\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdSelect") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"medium-5 column\" id=\"inputOnlineId\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdField") : stack1),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":9,"column":41}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div id=\"passcodeContainer\" class=\"medium-5 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"passwordInput")||(depth0 && lookupProperty(depth0,"passwordInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"passcodeField") : stack1),{"name":"passwordInput","hash":{},"data":data,"loc":{"start":{"line":12,"column":6},"end":{"line":12,"column":45}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"medium-2 column\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block spa-btn--medium\" type=\"submit\" id=\"signIn\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInBtn") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    <div class=\"small-12 medium-4 large-12 column hidden\" id=\"signin-with-mobile-app\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-with-mobile-app-button\" type=\"submit\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInWithMobileApp") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    <div class=\"small-12 column hidden\" id=\"signin-pwdless\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-pwdless-button\" type=\"button\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInPwdless") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"signin-pwdless-link\">\r\n    <div class=\"small-12 column\" >\r\n        "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInPwdlessLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":56,"column":48}}})) != null ? stack1 : "")
    + "\r\n        <span id=\"pwdless-loader-wh\" class=\"hidden circle-animation\">\r\n            <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n            <div class=\"loading-circle circle-inline\">\r\n              <div class=\"circle-bounce1\"></div>\r\n              <div class=\"circle-bounce2\"></div>\r\n              <div class=\"circle-bounce3\"></div>\r\n            </div>\r\n        </span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"signin-with-mobile-app-link\">\r\n    <div class=\"small-12 column\" >\r\n        "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":70,"column":8},"end":{"line":70,"column":54}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"mobileDeviceNotificationText\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n    <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n    <span class=\"circle-animation\">\r\n      <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n      <div class=\"loading-circle circle-inline\">\r\n        <div class=\"circle-bounce1\"></div>\r\n        <div class=\"circle-bounce2\"></div>\r\n        <div class=\"circle-bounce3\"></div>\r\n      </div>\r\n    </span>\r\n\r\n      <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"PwdlessFailedNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\"small-12 column ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 small-12 column ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"tryPwdlessAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":93,"column":61},"end":{"line":93,"column":99}}})) != null ? stack1 : "")
    + "</span>\r\n      <span id=\"try-again-loader-wh\" class=\"hidden circle-animation small-12 column ft-lt \">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n      </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\"><span class=\"ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":102,"column":65},"end":{"line":102,"column":118}}})) != null ? stack1 : "")
    + "</span><span class=\"ft-lt delimiter\"> | </span></span>\r\n      <span class=\"splash-desc btm-10 ft-lt\"><span class=\"ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":103,"column":65},"end":{"line":103,"column":120}}})) != null ? stack1 : "")
    + "</span></span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"PwdlessTempNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessTempNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":111,"column":45},"end":{"line":111,"column":106}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"PwdlessCurrentNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":119,"column":45},"end":{"line":119,"column":109}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"mobileDeviceGenericNotificationText\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n    <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceGenericNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"mobileDeviceMaximumAttemptNotificationText\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n    <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceMaximumAttemptNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"send-notification-again-wrapper\">\r\n    <div class=\"small-12 column\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"sendNotificationAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":137,"column":8},"end":{"line":137,"column":52}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"signin-with-passcode-wrapper\">\r\n    <div class=\"small-12 column\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscode") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":142,"column":8},"end":{"line":142,"column":49}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row hidden\" id=\"signin-with-passcode-instead-wrapper\">\r\n    <div class=\"small-12 column\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":147,"column":8},"end":{"line":147,"column":56}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row\">\r\n    <div class=\"medium-3 column\" id=\"saveOnlineIdCheckBox\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"saveOnlineId") : stack1),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":154,"column":6},"end":{"line":154,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"medium-9 column forgot-links\">\r\n      <div>"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"forgotOidPwd") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":157,"column":11},"end":{"line":157,"column":46}}})) != null ? stack1 : "")
    + "</div>\r\n      <div class=\"separator\"></div>\r\n      <div>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"infoLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n      <div class=\"separator\"></div>\r\n      <div>"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"enroll") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":161,"column":11},"end":{"line":161,"column":40}}})) != null ? stack1 : "")
    + "</div>\r\n    </div>\r\n  </div>\r\n  \r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"outageContent") : stack1),"==","sign-in-enabled-content",{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":166,"column":2},"end":{"line":194,"column":14}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row splash-title\" id=\"splash-title\">\r\n    <div class=\"column small-8 title\">\r\n      "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"column small-4 sign-in-btn\">\r\n      "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"signInBtn") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <span class=\"splash-desc\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"desc") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n  <div class=\"row\" id=\"splash-bottom-section\">\r\n    <div class=\"small-9 small-push-5 column\">\r\n      <span class=\"splash-bottom-link\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"minorOutageLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row splash-title major\" id=\"splash-title\">\r\n    "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    <br />\r\n    <span class=\"splash-desc\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"desc") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n  <div class=\"row\" id=\"splash-bottom-section\">\r\n    <div class=\"small-9 small-push-5 column\">\r\n      <span class=\"splash-bottom-link\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"majorOutageLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"horizontal horizontalPartial\">\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"disableSignin") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":195,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"BA360Skin") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":352,"column":7}}})) != null ? stack1 : "")
    + "  \r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"BA360Skin\">\r\n      <div class=\"row\" id=\"skip_to_signin\">\r\n    <div class=\"small-12 column\" id=\"signin-message\"></div>\r\n    <div class=\"small-12 column hidden\" id=\"dropDown\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdSelect") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":9,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-12 column\" id=\"inputOnlineId\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdField") : stack1),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":12,"column":6},"end":{"line":12,"column":41}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div id=\"passcodeContainer\" class=\"small-12 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"passwordInput")||(depth0 && lookupProperty(depth0,"passwordInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"passcodeField") : stack1),{"name":"passwordInput","hash":{},"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":15,"column":45}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n       \r\n    <div class=\"row\">\r\n      <div class=\"small-6 column\" id=\"saveOnlineIdCheckBox\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"saveOnlineId") : stack1),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":20,"column":10},"end":{"line":20,"column":43}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n      <div class=\"small-6 column forgot-links\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"forgotOidPwd") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":23,"column":10},"end":{"line":23,"column":45}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" id=\"securityHelp\">\r\n      <div class=\"small-8 column\">\r\n        "
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"infoLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n\r\n  <div class=\"row\" id=\"end-row\">\r\n    <div class=\"padding-left\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--small\" type=\"submit\" id=\"signIn\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInBtn") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    \r\n  <div class=\"padding-left\">\r\n      <button class=\"spa-btn spa-btn--secondary spa-btn--small\" id=\"openAccount\" class=\"open-account\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"open") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </button>\r\n  </div>\r\n    <div class=\"enrollLink-padding\">\r\n      <a href=\"#\" class=\"spa-ui-layer-link spa-fn spa-prevent-default-click\" id=\"enroll\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"enroll") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "<div class=\"spa-icon demo-caret-left\"></div></a>\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"small-12 medium-4 large-12 column hidden\" id=\"signin-with-mobile-app\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-with-mobile-app-button\" type=\"submit\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInWithMobileApp") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    <div class=\"small-12 column hidden\" id=\"signin-pwdless\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-pwdless-button\" type=\"button\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInPwdless") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-pwdless-link\">\r\n    <div  class=\"small-12 column\" > \r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInPwdlessLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":87,"column":10},"end":{"line":87,"column":50}}})) != null ? stack1 : "")
    + "\r\n          <span id=\"pwdless-loader-wh\" class=\"hidden circle-animation\">\r\n            <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n            <div class=\"loading-circle circle-inline\">\r\n              <div class=\"circle-bounce1\"></div>\r\n              <div class=\"circle-bounce2\"></div>\r\n              <div class=\"circle-bounce3\"></div>\r\n            </div>\r\n          </span>\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"row hidden\" id=\"signin-with-mobile-app-link\">\r\n      <div class=\"small-12 column\" >\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":101,"column":10},"end":{"line":101,"column":56}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"PwdlessFailedNotification\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n        <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <span class=\"ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"tryPwdlessAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":108,"column":47},"end":{"line":108,"column":85}}})) != null ? stack1 : "")
    + "</span>\r\n        <span id=\"try-again-loader-wh\" class=\"hidden circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":117,"column":47},"end":{"line":117,"column":100}}})) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":118,"column":47},"end":{"line":118,"column":102}}})) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"PwdlessTempNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessTempNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":125,"column":45},"end":{"line":125,"column":106}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"PwdlessCurrentNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":133,"column":45},"end":{"line":133,"column":109}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n    <div class=\"row hidden\" id=\"mobileDeviceNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"row hidden\" id=\"mobileDeviceGenericNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceGenericNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"mobileDeviceMaximumAttemptNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceMaximumAttemptNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row hidden\" id=\"send-notification-again-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"sendNotificationAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":169,"column":10},"end":{"line":169,"column":54}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-with-passcode-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscode") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":174,"column":10},"end":{"line":174,"column":51}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-with-passcode-instead-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":179,"column":10},"end":{"line":179,"column":58}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n  <div class=\"row\" id=\"skip_to_signin\">\r\n    <div class=\"small-12 column\" id=\"signin-message\"></div>\r\n    <div class=\"small-12 column hidden\" id=\"dropDown\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdSelect") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":188,"column":6},"end":{"line":188,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-12 column\" id=\"inputOnlineId\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"onlineIdField") : stack1),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":191,"column":6},"end":{"line":191,"column":41}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div id=\"passcodeContainer\" class=\"small-12 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"passwordInput")||(depth0 && lookupProperty(depth0,"passwordInput"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"passcodeField") : stack1),{"name":"passwordInput","hash":{},"data":data,"loc":{"start":{"line":194,"column":6},"end":{"line":194,"column":45}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-12 column\" id=\"saveOnlineIdCheckBox\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"saveOnlineId") : stack1),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":197,"column":6},"end":{"line":197,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-12 column\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block spa-btn--medium\" type=\"submit\" id=\"signIn\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInBtn") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    <div class=\"small-12 medium-4 large-12 column hidden\" id=\"signin-with-mobile-app\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-with-mobile-app-button\" type=\"submit\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInWithMobileApp") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    <div class=\"small-12 column hidden\" id=\"signin-pwdless\">\r\n      <button class=\"spa-btn spa-btn--primary spa-btn--block\" id=\"signin-pwdless-button\" type=\"button\">\r\n        <span>"
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"signInPwdless") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n      </button>\r\n    </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-pwdless-link\">\r\n    <div  class=\"small-12 column\" > \r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInPwdlessLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":241,"column":10},"end":{"line":241,"column":50}}})) != null ? stack1 : "")
    + "\r\n          <span id=\"pwdless-loader-wh\" class=\"hidden circle-animation\">\r\n            <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n            <div class=\"loading-circle circle-inline\">\r\n              <div class=\"circle-bounce1\"></div>\r\n              <div class=\"circle-bounce2\"></div>\r\n              <div class=\"circle-bounce3\"></div>\r\n            </div>\r\n          </span>\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"row hidden\" id=\"signin-with-mobile-app-link\">\r\n      <div class=\"small-12 column\" >\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":255,"column":10},"end":{"line":255,"column":56}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"small-12 column forgot-links\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"forgotOidPwd") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":260,"column":10},"end":{"line":260,"column":45}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"PwdlessFailedNotification\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n        <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <span class=\"ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"tryPwdlessAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":267,"column":47},"end":{"line":267,"column":85}}})) != null ? stack1 : "")
    + "</span>\r\n        <span id=\"try-again-loader-wh\" class=\"hidden circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithMobileAppLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":276,"column":47},"end":{"line":276,"column":100}}})) != null ? stack1 : "")
    + "</span>\r\n        <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"pwdlessSignInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":277,"column":47},"end":{"line":277,"column":102}}})) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"PwdlessTempNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessTempNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessTempNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":284,"column":45},"end":{"line":284,"column":106}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row hidden\" id=\"PwdlessCurrentNotification\">\r\n    <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <span class=\" ft-lt btm-10\"> "
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + " </span>\r\n      <span class=\"splash-desc btm-10 ft-lt\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"PwdlessCurrentNotificationPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":292,"column":45},"end":{"line":292,"column":109}}})) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n    <div class=\"row hidden\" id=\"mobileDeviceNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"circle-animation\">\r\n          <div class=\"circle-inline\">"
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"loadingAnimationText") : stack1), depth0))
    + "</div>\r\n          <div class=\"loading-circle circle-inline\">\r\n            <div class=\"circle-bounce1\"></div>\r\n            <div class=\"circle-bounce2\"></div>\r\n            <div class=\"circle-bounce3\"></div>\r\n          </div>\r\n        </span>\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"row hidden\" id=\"mobileDeviceGenericNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceGenericNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"mobileDeviceMaximumAttemptNotificationText\">\r\n      <div class=\"small-12 column diMessageTitle\" >\r\n      <h3>  "
    + ((stack1 = alias3(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceNotificationText") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <br />\r\n        <span class=\"splash-desc diMessageText\">"
    + ((stack1 = alias3(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileDeviceMaximumAttemptNotificationText") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row hidden\" id=\"send-notification-again-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"sendNotificationAgain") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":328,"column":10},"end":{"line":328,"column":54}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-with-passcode-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscode") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":333,"column":10},"end":{"line":333,"column":51}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n    <div class=\"row hidden\" id=\"signin-with-passcode-instead-wrapper\">\r\n      <div class=\"small-12 column\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"signInWithPasscodeInstead") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":338,"column":10},"end":{"line":338,"column":58}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"small-8 column\">\r\n      "
    + ((stack1 = alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"infoLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"small-4 column\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"enroll") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":347,"column":6},"end":{"line":347,"column":35}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n\r\n  </div>\r\n \r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"outageContent") : stack1),"==","sign-in-enabled-content",{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":355,"column":2},"end":{"line":383,"column":14}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row splash-title\" id=\"splash-title\">\r\n    <div class=\"column small-8 title\">\r\n      "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"column small-4 sign-in-btn\">\r\n      "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"signInBtn") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <span class=\"splash-desc\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"desc") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n  <div class=\"row\" id=\"splash-bottom-section\">\r\n    <div class=\"small-9 small-push-5 column\">\r\n      <span class=\"splash-bottom-link\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"minorOutage") : stack1)) != null ? lookupProperty(stack1,"minorOutageLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row splash-title major\" id=\"splash-title\">\r\n    "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    <br />\r\n    <span class=\"splash-desc\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"desc") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n  <div class=\"row\" id=\"splash-bottom-section\">\r\n    <div class=\"small-9 small-push-5 column\">\r\n      <span class=\"splash-bottom-link\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"majorOutage") : stack1)) != null ? lookupProperty(stack1,"majorOutageLayerHelper") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"vertical\">\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"disableSignin") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":384,"column":11}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.hp-login.modules/ah-hp-sign-in-module",
  "version": "1.3.62",
  "id": "signInModule",
  "containerID": "hpLoginAhHpSignInModule",
  "moduleName": "hp-login-ah-hp-sign-in-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "ah-hp-sign-in-module",
  "data": {
    "init": "ahHpSignInModuleJS",
    "options": {
      "endpoints": {
        "caWidgetLoadEntryUrl": "/login/rest/sas/sparta/entry/v1/CAWidgetLoad",
        "initAuthUrl": "/login/rest/sas/sparta/v2/initAuth",
        "initAuthPwdLess": "/login/rest/sas/sparta/entry/v1/initAuthentication",
        "VerifyAuthURLWH": "/login/rest/sas/sparta/v1/verifyAuthentication",
        "pollingUrl": "/login/rest/sas/sparta/v1/retrieveAuthStatus",
        "postAuthUrl": "/login/rest/sas/sparta/postAuth",
        "OLBStepupRedirect": "/sparta/login/ah-omni-secondfactor-auth",
        "iac": "/login/rest/sas/sparta/v2/iac",
        "uiLoggerUrl": "/sparta/client/helper/client-assets/",
        "captureJsStatus": "/login/rest/sas/sparta/v1/captureJsStatus",
        "openAccountURL": "/small-business/mobile-home",
        "enrollURL": "/auth/enroll/enroll-entry"
      },
      "js": {
        "jsEncrypt": "/pa/components/utilities/rsa-encryption-util/1.1/script/jsencrypt.min.js"
      }
    }
  },
  "moduleParams": [{
    "name": "submitAction",
    "type": "string",
    "values": [],
    "default": "",
    "description": "This property sets the URL to which the sign-in form will POST"
  }, {
    "name": "BA360Skin",
    "type": "string"
  }, {
    "name": "outageContent",
    "type": "string",
    "values": [],
    "default": "",
    "description": "This property sets whether to display static outage content or not, and what content to display."
  }, {
    "name": "SOURCE",
    "type": "string",
    "values": [],
    "default": "",
    "description": ""
  }, {
    "name": "USECASE",
    "type": "string",
    "values": [],
    "default": "",
    "description": ""
  }, {
    "name": "LOB",
    "type": "string",
    "values": [],
    "default": "",
    "description": ""
  }, {
    "name": "CLIENT",
    "type": "string",
    "values": [],
    "default": "",
    "description": ""
  }, {
    "name": "CHANNEL",
    "type": "string",
    "values": [],
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$2(context, {
      "helpers": {
        textInput,
        passwordInput,
        select,
        checkbox,
        link,
        layerContent,
        compare,
        json
      },
      "partials": {
        "horizontal": renderTemplate$1,
        "vertical": renderTemplate
      }
    });
  },
  "template": renderTemplate$2,
  "partials": {
    "horizontal": renderTemplate$1,
    "vertical": renderTemplate
  },
  "helpers": {
    textInput,
    passwordInput,
    select,
    checkbox,
    link,
    layerContent,
    compare,
    json
  },
  "dependencies": {
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0",
    "@sparta.global.helpers/radio-button-helper": "^1.0.0",
    "@sparta.global.helpers/checkbox-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.helpers/utils-helper": "^1.0.0",
    "@sparta.global.utilities/signin-fp-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jsencrypt": "2.3.1",
    "@sparta.authglobal.utilities/ah-common-utility": "^2.0.0",
    "@sparta.authglobal.utilities/ah-transport-utility": "^1.0.0",
    "@sparta.authglobal.utilities/ah-pwdless-common-utility": "^1.0.0",
    "@sparta.authglobal.utilities/ah-webbio-utility": "^1.0.0",
    "@sparta.login.utilities/ah-inauth-utility": "1.0.1",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0"
  },
  "stores": []
};

/* global Module */

/*
 * ah-hp-sign-in-module
 * module_js_id: ahHpSignInModuleJS
 *
 * Copyright (c) 2018-3-12 Vellore Suresh Shravan Kumar
 */
const OID_INPUT_ID = 'onlineId1';
const PASSCODE_INPUT_ID = 'passcode1';
const OID_SELECT_ID = 'onlineIdSelect';
const FORM_CLIENT_ID = 'signinClient';
const FORM_INFO_ID = 'signinInfo';
const SIGNIN_WITH_MOBILE_APP_LINK = 'signInWithMobileAppLink';
const SIGNIN_WITH_PASSCODE = "signin-with-passcode";
const SIGNIN_WITH_MOBILE_APP = "signin-with-mobile-app";
const SEND_NOTIFICATION_AGAIN = "send-notification-again";
const SIGNIN_WITH_PWDLESS = "signin-pwdless-button";
const SIGNIN_WITH_PWDLESS_LINK = "signin-pwdless-link";
const SIGNIN_WITH_PASSCODE_INSTEAD = "signin-with-passcode-instead";
const PWDLESS_SIGNIN_WITH_PASSCODE_INSTEAD = "pwdless-signin-with-passcode-instead";
const TEMP_SIGNIN_WITH_PASSCODE_INSTEAD = "temp-signin-with-passcode-instead";
const CURRENT_SIGNIN_WITH_PASSCODE_INSTEAD = "current-signin-with-passcode-instead";
const TRY_AGAIN_PWDLESS_WH = "try-again-pwdless-wh";
const PWDLESS_SIGNIN_WITH_MOBILE_APP = "pwdlessSignInWithMobileAppLink";
const OPEN_ACCOUNT = "openAccount";
const ENROLL_LINK = "enroll";
let polling = true;
let publicKey = "";
let diDenyMessage = false;
let errorCountPwdless = 0;
/**
 * ahHpSignInModuleJS Class
 * @extends Module
 */
class ahHpSignInModuleJS extends Module {
  /**
   * Creates an intance of ahHpSignInModuleJS
   * @param {*} options options
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.jcr = JSON.parse(this.settings.target.querySelector('#signin-jcr').dataset.jcr);
    this.isLarge = window.matchMedia('(min-width: 1025px)');
    this.isMediumUp = window.matchMedia('(min-width: 768px)');
    this.user = null;
    this.partialContainer = this.settings.target.querySelector('#signInPartialContent');
    this.signoffParamValue = this.SpartaFunctions.getUrlParam('page_msg');
    this.isSubmitted = false;
    this.ahPwdlessCommons = new AhPwdlessCommonsUtility();
    this.ahWebbio = new ahWebbioUtility({
      _,
      constructorParams: options,
      context: this,
      ahTransportUtility
    });
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
    this.apiEndPoints = {};
    this.basePath = ahCommonUtility.getBasePath(this.spaParams);
    this.endpoints = options.endpoints;
    this.apiEndPoints = ahCommonUtility.getEndPoints(options.endpoints, this.basePath);
    const self = this;
    this.bindThisContext(['handleInitAuth', '_triggerVerifyAuthWH', '_togglePwdlessLoader', 'handleSigninwithPwdLessTA', 'handleVerifyAuth', '_handlePwdlessError', '_GlobalVariable', '_handleRoute'], self, '');
  }
  bindThisContext(methods, context, suffix = 'Scoped') {
    const self = context;
    if (methods && Array.isArray(methods) && methods.length > 0) {
      methods.forEach((method, index) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }

  /*
   * @function  init
   * @description  Initiliazes the module
   * @returns {void}
   */
  init() {
    this.ahWebbio.callOptionB('login-home');
    this.ahWebbio.iaCall();
    this.subscribeEvents();
    this.handleSizeChange();
    this.loadAuthHelper();
    this.hideOpenAccount();
    this.ADAComplianceForBa360();
    this.isLarge.addListener(this.handleSizeChange.bind(this));
    if (spaParams.siteParams.disableSignin) return; // Chicken switch

    this.checkMediumSignOff();
    this.isMediumUp.addListener(this.triggerInAuth.bind(this));
    //if(!(this.ahPwdlessCommons._checkpwdlessEligibility(OID_SELECT_ID))){
    this.triggerInAuth();
    //}
    this.delegateEvent('change', `#${OID_SELECT_ID}`, this.showHideOnlineIdInput.bind(this));
    this.delegateEvent('input', `#${OID_INPUT_ID}`, this.handlePWMSelect.bind(this));
    this.delegateEvent('submit', `#${FORM_CLIENT_ID}`, this.handleSubmit.bind(this));
    this.delegateEvent('focusin', '.form-end', ahHpSignInModuleJS.focusMediumSignInClose.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_MOBILE_APP_LINK}`, this.handleSigninWithMobileAppClick.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_PASSCODE}`, this.handleSigninwithPasscodeClick.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_PWDLESS}`, this.handleSigninwithPwdLess.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_MOBILE_APP}`, this.handleSigninWithMobileAppClick.bind(this));
    this.delegateEvent('click', `#${PWDLESS_SIGNIN_WITH_MOBILE_APP}`, this.handleSigninWithMobileAppClick.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_PWDLESS_LINK}`, this.handleSigninwithPwdLess.bind(this));
    this.delegateEvent('click', `#${TRY_AGAIN_PWDLESS_WH}`, this.handleSigninwithPwdLessTA.bind(this));
    this.delegateEvent('click', `#${SEND_NOTIFICATION_AGAIN}`, this.handleSendNotificationAgain.bind(this));
    this.delegateEvent('click', `#${SIGNIN_WITH_PASSCODE_INSTEAD}`, this.handleSigninwithPasscodeClick.bind(this));
    this.delegateEvent('click', `#${PWDLESS_SIGNIN_WITH_PASSCODE_INSTEAD}`, this.handleSigninwithPasscodeClick.bind(this));
    this.delegateEvent('click', `#${TEMP_SIGNIN_WITH_PASSCODE_INSTEAD}`, this.handleSigninwithPasscodeClick.bind(this));
    this.delegateEvent('click', `#${CURRENT_SIGNIN_WITH_PASSCODE_INSTEAD}`, this.handleSigninwithPasscodeClick.bind(this));
    this.delegateEvent('change', `#${OID_SELECT_ID}`, this.handleShowSignInWithMobileButton.bind(this));
    this.delegateEvent('click', `#${OPEN_ACCOUNT}`, this.handleOpenAnAccountButton.bind(this));
    this.delegateEvent('click', `#${ENROLL_LINK}`, this.handleEnrollLink.bind(this));
    if (typeof input !== 'undefined' && !spaParams.siteParams.disableBrowserFingerprint) {
      input.parse_data('f_variable');
    }

    // Check if it's been submitted before JS initialized
    if (window.signInSubmitted) {
      this.handleSubmit();
    }
    let element = document.createElement('script');
    element.setAttribute('src', `${spaParams.siteParams.secureHost}/pa/components/utilities/ah-continuous-auth-util/1.1/deploy/cau-login.js`);
    element.setAttribute('async', 'true');
    const head = document.getElementsByTagName('head')[0] || document.body;
    head.appendChild(element);
  }
  /**
   * @function loadAuthHelper
   * @description To load anti-phishing js
   * @returns {void}
   */
  loadAuthHelper() {
    var loader = document.createElement("script");
    loader.type = "text/javascript";
    if (!(window.location.host.indexOf('localhost') > -1)) {
      loader.src = this.spaParams.siteParams.secureHost + "/client/helper/spa-assets/components/utilities/client-helper/authhub-controller/authhub-helper/1.0.0/js/authhub-helper.js";
      document.getElementsByTagName("head")[0].appendChild(loader);
      document.cookie = 'DomainUrl=' + this.spaParams.siteParams.secureHost;
    }
  }

  /**
  * @function  hideOpenAnAccount
  * @description To hide open an account button at the bottom of the module
  * @returns {void}
  */
  hideOpenAccount() {
    //if it is BA360 flow, hide open an account button on the bottom of the module
    if (document.querySelector(".business-advantage")) {
      document.getElementsByClassName('open-account-link')[0].classList.add("hidden");
    } else {
      document.getElementsByClassName('open-account-link')[0].classList.remove("hidden");
    }
  }
  //       /**
  //  * @function ADAComplianceForBa360
  //  * @description ADA fixes for BA360 Compliance
  //  * @returns {void}
  //  */
  ADAComplianceForBa360() {
    if (document.querySelector(".business-advantage")) {
      //document.querySelector('#inputOnlineId').children[0].children[1].setAttribute('aria-hidden', 'true');
      //document.querySelector('#passcodeContainer').children[0].children[1].setAttribute('aria-hidden', 'true');
      //document.querySelector('#security').children[0].setAttribute("aria-hidden","true");
      document.querySelector('#saveOnlineIdCheckBox').children[0].children[0].children[0].children[0].setAttribute("aria-label", "Save User ID");
      //document.querySelector('#saveOnlineIdCheckBox').children[0].children[0].children[0].children[2].setAttribute("aria-hidden", "true")
    }
  }

  /**
  * @function handleOpenAnAccountButton
  * @description redirect to open an account page
  * @returns {void}
  */
  handleOpenAnAccountButton() {
    //const openAccountURL = this.apiEndPoints.openAccountURL;
    window.location.href = "https://business.bankofamerica.com/en/deposits/checking-accounts/"; //place prod url as place holder
  }

  /**
  * @function handleOpenAnAccountButton
  * @description redirect to enroll Link
  * @returns {void}
  */
  handleEnrollLink() {
    //const enrollLinkRedirect = this.apiEndPoints.enrollURL;
    window.location.href = "https://secure.bankofamerica.com/auth/enroll/enroll-entry/"; //place prod url here as place holder
  }

  /**
   * @function subscribeEvents
   * @description Subscribe to events
   * @returns {void}
   */
  subscribeEvents() {
    this.parentModule;
    this.Events.sub('mediumLoginState', res => {
      if (res.data.expand) {
        this.settings.target.setAttribute('aria-hidden', 'false');
      } else {
        this.settings.target.setAttribute('aria-hidden', 'true');
      }
    });
    this.Events.sub('mediumLoginFocus', () => {
      document.getElementById(FORM_CLIENT_ID).focus();
    });
    this.Events.sub(this.Events.EVENTS.APP_CONTAINER_LOADED, e => {
      // this.ahWebbio.iaCall('home'); 
    });
  }

  /**
   * @function renderPartial
   * @description Renders vertical or horizontal partial templates due to differences with medium and large
   * @param {string} [templatePartial='vertical'] - templatePartial to render
   * @returns {void}
   */
  renderPartial(templatePartial = 'vertical') {
    const template = _moduleConfig.partials[templatePartial];
    this.partialContainer.innerHTML = template({
      data1: this.jcr,
      site: this.spaParams.siteParams,
      module: this.params
    });
  }

  /**
   * @function initAfterRender
   * @description Required after rendering of partial content
   * @returns {void}
   */
  initAfterRender() {
    //  this.handleShowSignInWithMobileButton();
    if (this.signoffParamValue === 'signoff') {
      this.displayMessage(this.jcr.signOut);
    }
    const showOnlineIDInput = this.prefillCookieforDropDown();
    if (showOnlineIDInput === false) {
      ahHpSignInModuleJS.focusOnlineIdField();
    } else {
      const dropDownOption = document.getElementById(OID_SELECT_ID);
      dropDownOption.focus();
    }
    this.isSubmitted = false;
    this.handleShowSignInWithMobileButton();
  }

  /**
   * @function handleSizeChange
   * @description Size change handler that will not rerender over the pre-baked/built sign-in.
   * @returns {void}
   */
  handleSizeChange() {
    if (this.isLarge.matches) {
      if (this.settings.target.querySelector('.horizontal')) {
        this.renderPartial('vertical');
        if (document.querySelector(".business-advantage")) {
          document.getElementsByClassName('open-account-link')[0].classList.add("hidden");
        }
      }
    } else {
      this.renderPartial('horizontal');
    }
    this.initAfterRender();
  }

  /**
   * @function checkMediumSignOff
   * @description Checks signoff param for medium viewport
   * @returns {void}
   */
  checkMediumSignOff() {
    if (this.signoffParamValue === 'signoff') {
      // Display the sign in to show message
      if (spartaMediaQueryUtility.getCurrentViewport().currentViewport === 'medium') {
        // due to partial rendering
        setTimeout(() => {
          document.getElementById('LOGIN_MEDIUM').click();
        }, 0);
      }
    }
  }

  /**
   * @function triggerInAuth
   * @description Triggers inAuth to generate the fingerPrint
   * @returns { void }
   */
  triggerInAuth() {
    if (spaParams.siteParams.disableInAuth) return;
    if (this.isMediumUp.matches && !this.user) {
      if (spaParams.siteParams.enableEntryInAuth) {
        this.user = {
          config: {
            ccPath: `${spaParams.siteParams.secureHost}/login/sign-in/entry/cc.go`,
            formId: FORM_INFO_ID,
            flagsToCollect: 155687923
          }
        };
      } else {
        this.user = {
          config: {
            ccPath: `${spaParams.siteParams.secureHost}/login/sign-in/cc.go`,
            formId: FORM_INFO_ID,
            flagsToCollect: 155687923
          }
        };
      }
      signInFpUtility.inauthFp.fingerprint(this.user);
    }
  }

  /**
   * @function showHideOnlineIdInput
   * @description Toggles the onlineId Input element.
   * @returns { void }
   */
  showHideOnlineIdInput() {
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    const signIn = this.settings.target.querySelector('#signIn');
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    const signInWithMobileAppLink = this.settings.target.querySelector('#signin-with-mobile-app-link');
    const signInWithMobileAppLinkText = this.settings.target.querySelector('#signInWithMobileAppLink');
    const signInPwdless = this.settings.target.querySelector('#signin-pwdless');
    const signInPwdlessLink = this.settings.target.querySelector('#signin-pwdless-link');
    const enroll = this.settings.target.querySelector('#enroll');
    //TODO:enroll and secure session disappearing
    const enrollDiv = enroll.parentNode;
    const securityHelp = this.settings.target.querySelector('#security');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const mobileDeviceNotificationText = this.settings.target.querySelector('#mobileDeviceNotificationText');
    const sendNotificationAgain = this.settings.target.querySelector('#send-notification-again');
    const sendNotificationAgainWrapper = this.settings.target.querySelector('#send-notification-again-wrapper');
    const mobileDeviceGenericNotificationText = this.settings.target.querySelector('#mobileDeviceGenericNotificationText');
    const mobileDeviceMaximumAttemptNotificationText = this.settings.target.querySelector('#mobileDeviceMaximumAttemptNotificationText');
    const signinWithPasscodeInstead = this.settings.target.querySelector('#signin-with-passcode-instead');
    const signinWithPasscodeInsteadWrapper = this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
    if (selectedID === 'useAnother') {
      document.getElementById('anotherOnlineIDFlag').value = 'Y';
      const dropDownElem = this.settings.target.querySelector('#dropDown');
      dropDownElem.classList.add('hidden');
      const inputElem = this.settings.target.querySelector('#inputOnlineId');
      inputElem.classList.remove('hidden');
      const saveIDCheck = this.settings.target.querySelector('#saveOnlineIdCheckBox');
      saveIDCheck.classList.remove('hidden');
      securityHelp.classList.remove('hidden');
      enrollDiv.classList.remove('hidden');
      if (this.settings.target.querySelector('.horizontalPartial')) {
        document.getElementsByClassName('separator')[0].classList.remove('hidden');
        document.getElementsByClassName('separator')[1].classList.remove('hidden');
      }
      passCodeField.classList.remove('hidden');
      signIn.classList.remove('hidden');
      signIn.parentElement.classList.remove('hidden');
      forgotOidPwd.classList.remove('hidden');
      if (signInWithMobileAppLink) {
        if (this.jcr.switch.enableDI === "true") {
          signInWithMobileAppLink.classList.remove('hidden');
          signInWithMobileAppLinkText.classList.remove('hidden');
        }
      }
      signInPwdless.classList.add('hidden');
      signInPwdlessLink.classList.add('hidden');
      signInWithMobileApp.classList.add('hidden');
      if (signInWithPasscode) {
        signInWithPasscode.classList.add('hidden');
      }
      if (signinWithPasscodeInstead) {
        signinWithPasscodeInstead.classList.add('hidden');
      }
      signInWithPasscodeWrapper.classList.add('hidden');
      signinWithPasscodeInsteadWrapper.classList.add('hidden');
      mobileDeviceNotificationText.classList.add('hidden');
      if (sendNotificationAgain) {
        sendNotificationAgain.classList.add('hidden');
      }
      sendNotificationAgainWrapper.classList.add('hidden');
      mobileDeviceGenericNotificationText.classList.add('hidden');
      mobileDeviceMaximumAttemptNotificationText.classList.add('hidden');
      ahHpSignInModuleJS.focusOnlineIdField();
    }
    //    this.handleShowSignInWithMobileButton();
  }

  /**
   * @function handleSubmit
   * @description Handle the submit event.
   * @param {Event} e submit event to bind to
   * @returns { boolean } returns sign in success
   */
  handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.isSubmitted) return;
    this.isSubmitted = true;
    this.displayMessage('');
    ahHpSignInModuleJS.submitLoader('show');
    const onlineIdField = document.getElementById(OID_INPUT_ID);
    const passCodeField = document.getElementById(PASSCODE_INPUT_ID);
    const onlineIdValue = onlineIdField.value.trim();
    const passcodeValue = passCodeField.value.trim();
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value.trim();
    const isOnlineIDHidden = document.getElementById('inputOnlineId').classList.contains('hidden');
    const passcodeContainer = this.settings.target.querySelector('#passcodeContainer');
    const isPassCodeContainerHidden = passcodeContainer.classList.contains('hidden');
    let hasError = false;
    if (bactm && typeof bactm.manualLinkClick === 'function') {
      // eslint-disable-next-line no-script-url - CoreMetrics requirement
      bactm.manualLinkClick('javascript:void(0);', 'signIn');
    }
    const asterisks = onlineIdValue.match(/\*+/);
    if (asterisks && asterisks[0] === onlineIdValue) {
      onlineIdField.value = '';
      this.displayMessage(this.jcr.onlineIdErrorMsg, 'alert');
      hasError = true;
    }
    if (!isOnlineIDHidden && !onlineIdValue) {
      if (e.submitter.id == 'openAccount') {
        this.displayMessage('');
      } else {
        this.displayMessage(this.jcr.onlineIdErrorMsg, 'alert');
      }
      hasError = true;
    }
    if (!isPassCodeContainerHidden && !passcodeValue && !hasError) {
      this.displayMessage(this.jcr.PassCodeErrorMsg, 'alert');
      hasError = true;
    }
    if (hasError) {
      ahHpSignInModuleJS.submitLoader('hide');
      this.isSubmitted = false;
      return;
    }
    // Post Parameters
    document.getElementById('locale').value = document.getElementsByTagName('html')[0].getAttribute('lang');
    if (selectedID === 'useAnother') {
      document.getElementById('anotherOnlineIDFlag').value = 'Y';
    }
    if (selectedID !== 'useAnother' && selectedID.length) {
      document.getElementById('Access_ID_1').value = selectedID;
    }
    if (selectedID !== 'useAnother') {
      document.getElementById('anotherOnlineIDFlag').value = 'N';
    }
    document.getElementById('dltoken').value = location.search.substring(1).replace(/^&/, '');
    document.getElementById('reason').value = '';
    document.getElementById('passcode').value = passcodeValue;
    document.getElementById('onlineId').value = isOnlineIDHidden ? '' : onlineIdValue;
    const saveOnlineId = document.getElementById('saveOnlineId');
    if (saveOnlineId.checked === true) {
      document.getElementById('saveMyID').value = 'Y';
    } else {
      document.getElementById('saveMyID').value = 'N';
    }
    const webAuthAPI = document.getElementById('webAuthAPI').value = navigator.credentials ? true : false;
    if (webAuthAPI === true) {
      document.getElementById('webAuthAPI').value = 'true';
    } else {
      document.getElementById('webAuthAPI').value = 'false';
    }
    const multiIdList = this.getMultiIdList();
    if (multiIdList.length > 0 && selectedID !== 'useAnother') {
      document.getElementById('multiID').value = multiIdList[dropDownOptionElem.selectedIndex];
    }
    onlineIdField.value = onlineIdField.value.replace(/./g, '*');
    passCodeField.value = passCodeField.value.replace(/./g, '*');
    const formInfo = document.getElementById(FORM_INFO_ID);
    signInFpUtility.inauthFp.prepareIAData(() => {
      // safari will not display the loading indication without the timeout
      setTimeout(() => {
        formInfo.submit();
      }, 0);
    });
    if (typeof cdApi === 'undefined') {
      this.ahWebbio._triggerUiWebServerLogger('BehBio SDK is not loaded on submit');
    }
  }

  /**
   * @function displayMessage
   * @description Displays a message to the user
   * @param {String} message message to display
   * @returns { void }
   */
  displayMessage(message = '', role = '') {
    const messageElem = this.settings.target.querySelector('#signin-message');
    messageElem.innerHTML = message;
    if (role) {
      messageElem.setAttribute('role', role);
    } else {
      messageElem.removeAttribute('role');
    }
  }

  /**
   * @function prefillCookieforDropDown
   * @description Prefills dropdown based on contents of signin prefill cookie
   * @returns { boolean } true if cookie present, false otherwise.
   */
  prefillCookieforDropDown() {
    const olbSigninPrefillMultiSecureCookie = this.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
    const onlineIdList = olbSigninPrefillMultiSecureCookie.split('||');

    // OLB security center adds "" instead of clearing
    if (!olbSigninPrefillMultiSecureCookie.includes(':')) return false;
    if (!olbSigninPrefillMultiSecureCookie || !onlineIdList) return false;
    const onlineIdsForDropDown = [];
    onlineIdList.forEach((onlineId, i) => {
      onlineIdsForDropDown[i] = onlineIdList[i].split(':')[0];
    });
    if (!onlineIdsForDropDown) return false;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    dropDownElem.classList.remove('hidden');
    const onlineIDElem = this.settings.target.querySelector('#inputOnlineId');
    onlineIDElem.classList.add('hidden');
    const saveIDCheck = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    saveIDCheck.classList.add('hidden');
    const dropDownOption = document.getElementById(OID_SELECT_ID);
    dropDownOption.length = 0;
    onlineIdsForDropDown.forEach(dropDownId => {
      const option = document.createElement('option');
      option.text = dropDownId;
      option.value = dropDownId;
      dropDownOption.appendChild(option);
    });
    const option = document.createElement('option');
    option.text = this.jcr.useAnotherID;
    option.value = 'useAnother';
    dropDownOption.appendChild(option);
    ahHpSignInModuleJS.focusPasscodeField();
    return true;
  }

  /**
   * @function getMultiIdList
   * @description Returns the multiId list from the coookie
   * @returns { Object } the mutiIdList
   */
  getMultiIdList() {
    const multiIdList = [];
    const olbSigninPrefillMultiSecureCookie = this.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure');
    if (!olbSigninPrefillMultiSecureCookie) {
      return multiIdList;
    }
    const onlineIdList = olbSigninPrefillMultiSecureCookie.split('||');
    if (onlineIdList === undefined || onlineIdList == null || onlineIdList.length <= 0) {
      return multiIdList;
    }
    onlineIdList.forEach((onlineId, i) => {
      multiIdList[i] = onlineIdList[i].split(':')[1];
    });
    return multiIdList;
  }
  /**
  * @function handlePWMSelect
  * @description handler function when PWM is selected
  * @returns {void}
  */
  handlePWMSelect() {
    const onlineIDElem = this.settings.target.querySelector('#inputOnlineId');
    const onlineIDField = this.settings.target.querySelector(`#${OID_INPUT_ID}`);
    const isOnlineIDElemFocussed = document.activeElement === onlineIDField;
    const PwdField = this.settings.target.querySelector(`#${PASSCODE_INPUT_ID}`);
    const isPwdFocussed = document.activeElement === PwdField;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    if (!isOnlineIDElemFocussed && onlineIDField.value && onlineIDField.value !== '' && isPwdFocussed) {
      dropDownElem.classList.add('hidden');
      onlineIDElem.classList.remove('hidden');
    }
  }
  /**
  * @function isDigitalUser
  * @description checking whether the user is digital
  * @returns {void}
  */
  isDigitalUser() {
    const pwdlCookie = this.SpartaFunctions.spartaGetCookie('pwdl').trim();
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const olbSigninPrefillMultiSecureCookie = this.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
    const onlineIdList = olbSigninPrefillMultiSecureCookie.split('||');
    let selectedEncryptedID;
    let selectedID = "";
    if (dropDownOptionElem) {
      selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
      for (let i = 0; i < onlineIdList.length; i++) {
        onlineIdList[i].split(':');
        if (onlineIdList[i].indexOf(selectedID) > -1) {
          selectedEncryptedID = onlineIdList[i].split(':')[1];
        }
      }
    }
    if (selectedID && pwdlCookie && pwdlCookie.indexOf(selectedEncryptedID) > -1) {
      return true;
    } else {
      return false;
    }
  }

  /**
  * @function handleShowSignInWithMobileButton
  * @description checking sign in with mobile button
  * @returns {void}
  */
  handleShowSignInWithMobileButton() {
    this.settings.target.querySelector('#inputOnlineId');
    const saveOnlineId = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const signInPwdless = this.settings.target.querySelector('#signin-pwdless');
    const signInWithPwdlessLink = this.settings.target.querySelector('signin-pwdless-link');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    this.settings.target.querySelector('#dropDown');
    const signIn = this.settings.target.querySelector('#signIn');
    const securityHelp = this.settings.target.querySelector('#security');
    const enroll = this.settings.target.querySelector('#enroll');
    const enrollDiv = enroll.parentNode;
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    this.settings.target.querySelector('#signInWithMobileAppLink');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signinWithPasscodeInstead = this.settings.target.querySelector('#signin-with-passcode-instead');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const signinWithPasscodeInsteadWrapper = this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    document.getElementById(OID_INPUT_ID);
    const signInWithMobileAppLink = this.settings.target.querySelector('#signin-with-mobile-app-link');
    const signInPwdlessLink = this.settings.target.querySelector('#signin-pwdless-link');
    const securityHelpParent = securityHelp.parentNode;
    const open = this.settings.target.querySelector('#open');
    const openAccount = open.parentNode;
    ahHpSignInModuleJS.submitLoader('hide', 'signin-with-mobile-app-button');
    if (this.ahPwdlessCommons._checkpwdlessEligibility(OID_SELECT_ID)) {
      signInPwdless.classList.remove('hidden');
      if (signInWithPasscode) {
        signInWithPasscode.classList.remove('hidden');
      }
      signInWithPasscodeWrapper.classList.remove('hidden');
      passCodeField.classList.add('hidden');
      saveOnlineId.classList.add('hidden');
      signInWithMobileApp.classList.add('hidden');
      signIn.classList.add('hidden');
      signIn.parentElement.classList.add('hidden');
      forgotOidPwd.classList.add('hidden');
      if (signInPwdlessLink) {
        signInPwdlessLink.classList.add('hidden');
      }
      if (signinWithPasscodeInstead) {
        signinWithPasscodeInstead.classList.add('hidden');
      }
      signinWithPasscodeInsteadWrapper.classList.add('hidden');
      enrollDiv.classList.add('hidden');
      securityHelp.classList.add('hidden');
      if (this.settings.target.querySelector('.horizontalPartial')) {
        document.getElementsByClassName('separator')[0].classList.add('hidden');
        document.getElementsByClassName('separator')[1].classList.add('hidden');
      }
      openAccount.classList.remove('hidden');
      if (this.isDigitalUser()) {
        if (signInWithMobileAppLink) {
          signInWithMobileAppLink.classList.remove('hidden');
        }
      }
    } else if (this.isDigitalUser()) {
      signInWithMobileApp.classList.remove('hidden');
      if (signInWithPasscode) {
        signInWithPasscode.classList.remove('hidden');
      }
      signInWithPasscodeWrapper.classList.remove('hidden');
      passCodeField.classList.add('hidden');
      saveOnlineId.classList.add('hidden');
      signIn.classList.add('hidden');
      signIn.parentElement.classList.add('hidden');
      forgotOidPwd.classList.add('hidden');
      if (signInWithMobileAppLink) {
        signInWithMobileAppLink.classList.add('hidden');
      }
      if (signinWithPasscodeInstead) {
        signinWithPasscodeInstead.classList.add('hidden');
      }
      signinWithPasscodeInsteadWrapper.classList.add('hidden');
      enrollDiv.classList.add('hidden');
      securityHelp.classList.add('hidden');
      if (this.settings.target.querySelector('.horizontalPartial')) {
        document.getElementsByClassName('separator')[0].classList.add('hidden');
        document.getElementsByClassName('separator')[1].classList.add('hidden');
      }
      openAccount.classList.remove('hidden');
      if (signInWithPwdlessLink) {
        signInWithPwdlessLink.classList.add('hidden');
      }
    } else {
      if (this.jcr.switch.enableDI === "true") {
        signInWithMobileApp.classList.add('hidden');
        if (signInWithPasscode) {
          signInWithPasscode.classList.add('hidden');
        }
        signInWithPasscodeWrapper.classList.add('hidden');
        passCodeField.classList.remove('hidden');
        saveOnlineId.classList.remove('hidden');
        signIn.classList.remove('hidden');
        signIn.parentElement.classList.remove('hidden');
        forgotOidPwd.classList.remove('hidden');
        if (signInWithMobileAppLink) {
          signInWithMobileAppLink.classList.remove('hidden');
        }
        if (signInWithPwdlessLink) {
          signInWithPwdlessLink.classList.add('hidden');
        }
        if (signinWithPasscodeInstead) {
          signinWithPasscodeInstead.classList.add('hidden');
        }
        signinWithPasscodeInsteadWrapper.classList.add('hidden');
        enrollDiv.classList.remove('hidden');
        securityHelp.classList.add('hidden');
        if (this.settings.target.querySelector('.horizontalPartial')) {
          document.getElementsByClassName('separator')[0].classList.add('hidden');
          document.getElementsByClassName('separator')[1].classList.add('hidden');
        }
        openAccount.classList.remove('hidden');
        securityHelpParent.appendChild(forgotOidPwd);
      } else {
        signInWithMobileAppLink.classList.add('hidden');
      }
    }
  }
  /**
  * @function handleMobileAppClick
  * @description handling mobile app click function
  * @returns {void}
  */
  handleMobileAppClick() {
    const oidInput = this.settings.target.querySelector('#inputOnlineId');
    const saveOnlineId = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    const signIn = this.settings.target.querySelector('#signIn');
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    const signInWithMobileAppLink = this.settings.target.querySelector('#signInWithMobileAppLink');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const checkOnlineIDSaved = this.prefillCookieforDropDown();
    this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    this.settings.target.querySelector('#signin-with-passcode-instead');
    passCodeField.classList.add('hidden');
    saveOnlineId.classList.add('hidden');
    signIn.classList.add('hidden');
    signIn.parentElement.classList.add('hidden');
    forgotOidPwd.classList.add('hidden');
    signInWithMobileAppLink.classList.add('hidden');
    signInWithMobileApp.classList.remove('hidden');
    signInWithPasscode.classList.remove('hidden');
    signInWithPasscodeWrapper.classList.remove('hidden');
    if (checkOnlineIDSaved) {
      oidInput.classList.add('hidden');
      dropDownElem.classList.remove('hidden');
    } else {
      oidInput.classList.remove('hidden');
      dropDownElem.classList.add('hidden');
    }
  }

  /**
  * @function _triggerPollingService
  * @description triggering polling service function
  * @returns {void}
  */
  _triggerPollingService() {
    const me = this;
    const oidInput = this.settings.target.querySelector('#inputOnlineId');
    const saveOnlineId = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    const signIn = this.settings.target.querySelector('#signIn');
    const securityHelp = this.settings.target.querySelector('#security');
    const enroll = this.settings.target.querySelector('#enroll');
    const enrollDiv = enroll.parentNode;
    const open = this.settings.target.querySelector('#open');
    const openAccount = open.parentNode;
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    const signInWithMobileAppLink = this.settings.target.querySelector('#signInWithMobileAppLink');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const mobileDeviceNotificationText = this.settings.target.querySelector('#mobileDeviceNotificationText');
    const sendNotificationAgain = this.settings.target.querySelector('#send-notification-again');
    const sendNotificationAgainWrapper = this.settings.target.querySelector('#send-notification-again-wrapper');
    const mobileDeviceGenericNotificationText = this.settings.target.querySelector('#mobileDeviceGenericNotificationText');
    const mobileDeviceMaximumAttemptNotificationText = this.settings.target.querySelector('#mobileDeviceMaximumAttemptNotificationText');
    const signinWithPasscodeInstead = this.settings.target.querySelector('#signin-with-passcode-instead');
    const signinWithPasscodeInsteadWrapper = this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    const signoutErrorMessage = document.getElementById('signin-message');
    const pollingUrl = me.apiEndPoints.pollingUrl;
    const ajaxOptions = {
      method: 'GET',
      url: pollingUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      dataType: 'json',
      headers: {
        'content-type': 'application/json',
        clientAIT: '41339',
        accept: 'application/json',
        'cache-control': 'no-cache'
      }
    };
    ahTransportUtility._serviceCall(ajaxOptions, response => {
      const data = response.responseData;
      if (polling) {
        if (data && data.Completion.value && data.Completion.value === 'PENDING') {
          ahHpSignInModuleJS.submitLoader('show', 'mobileDeviceNotificationText');
          diDenyMessage = false;
          oidInput.classList.add('hidden');
          passCodeField.classList.add('hidden');
          saveOnlineId.classList.add('hidden');
          signIn.classList.add('hidden');
          signIn.parentElement.classList.add('hidden');
          forgotOidPwd.classList.add('hidden');
          signInWithMobileAppLink.classList.add('hidden');
          dropDownElem.classList.add('hidden');
          signInWithMobileApp.classList.add('hidden');
          signInWithPasscode.classList.add('hidden');
          signinWithPasscodeInstead.classList.remove('hidden');
          signInWithPasscodeWrapper.classList.add('hidden');
          signinWithPasscodeInsteadWrapper.classList.remove('hidden');
          mobileDeviceNotificationText.classList.remove('hidden');
          sendNotificationAgain.classList.remove('hidden');
          sendNotificationAgainWrapper.classList.remove('hidden');
          mobileDeviceGenericNotificationText.classList.add('hidden');
          mobileDeviceMaximumAttemptNotificationText.classList.add('hidden');
          enrollDiv.classList.add('hidden');
          securityHelp.classList.add('hidden');
          openAccount.classList.add('hidden');

          //signoutErrorMessage.classList.add('hidden');
          setTimeout(() => {
            me._triggerPollingService();
          }, 5000);
        } else if (data && data.Completion.value && data.Completion.value === 'ALLOW') {
          me._triggerPostAuthService();
        } else if (data && data.Completion.value && data.Completion.value === 'DENY' || data && data.Completion.value && data.Completion.value === 'FAILED') {
          diDenyMessage = true;
          oidInput.classList.add('hidden');
          passCodeField.classList.add('hidden');
          saveOnlineId.classList.add('hidden');
          signIn.classList.add('hidden');
          signIn.parentElement.classList.add('hidden');
          forgotOidPwd.classList.add('hidden');
          signInWithMobileAppLink.classList.add('hidden');
          dropDownElem.classList.add('hidden');
          signInWithMobileApp.classList.add('hidden');
          signInWithPasscode.classList.add('hidden');
          signinWithPasscodeInstead.classList.remove('hidden');
          signInWithPasscodeWrapper.classList.add('hidden');
          signinWithPasscodeInsteadWrapper.classList.remove('hidden');
          mobileDeviceNotificationText.classList.add('hidden');
          mobileDeviceMaximumAttemptNotificationText.classList.remove('hidden');
          sendNotificationAgain.classList.add('hidden');
          sendNotificationAgainWrapper.classList.add('hidden');
          mobileDeviceGenericNotificationText.classList.add('hidden');
          enrollDiv.classList.add('hidden');
          securityHelp.classList.add('hidden');
          openAccount.classList.add('hidden');
          signoutErrorMessage.classList.add('hidden');
        }
      }
    });
  }

  /**
  * @function _triggerPostAuthService
  * @description triggering post Auth service call
  * @returns {void}
  */
  _triggerPostAuthService() {
    const me = this;
    const postAuthUrl = me.apiEndPoints.postAuthUrl;
    const ajaxOptions = {
      method: 'GET',
      url: postAuthUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      dataType: 'json',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        'cache-control': 'no-cache'
      }
    };
    ahTransportUtility._serviceCall(ajaxOptions, response => {
      const data = response.responseData;
      window.location.replace(data.return2Url);
    });
  }

  /**
  * @function _triggerInitAuthService
  * @description triggering init Auth service call
  * @returns {void}
  */
  _triggerInitAuthService() {
    const that = this;
    const signoutErrorMessage = document.getElementById('signin-message');
    const oidInput = this.settings.target.querySelector('#inputOnlineId');
    const saveOnlineId = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const signInWithPwdless = this.settings.target.querySelector('#signin-pwdless');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    const signIn = this.settings.target.querySelector('#signIn');
    const securityHelp = this.settings.target.querySelector('#security');
    const enroll = this.settings.target.querySelector('#enroll');
    const enrollDiv = enroll.parentNode;
    const open = this.settings.target.querySelector('#open');
    const openAccount = open.parentNode;
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    const signInWithMobileAppLink = this.settings.target.querySelector('#signInWithMobileAppLink');
    const signInWithPwdlessLink = this.settings.target.querySelector('signin-pwdless-link');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const mobileDeviceNotificationText = this.settings.target.querySelector('#mobileDeviceNotificationText');
    const sendNotificationAgain = this.settings.target.querySelector('#send-notification-again');
    const sendNotificationAgainWrapper = this.settings.target.querySelector('#send-notification-again-wrapper');
    const mobileDeviceGenericNotificationText = this.settings.target.querySelector('#mobileDeviceGenericNotificationText');
    const mobileDeviceMaximumAttemptNotificationText = this.settings.target.querySelector('#mobileDeviceMaximumAttemptNotificationText');
    const signinWithPasscodeInstead = this.settings.target.querySelector('#signin-with-passcode-instead');
    const signinWithPasscodeInsteadWrapper = this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    this.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const iaValue = document.getElementById("_ia").value;
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
    const selectedIDIndex = dropDownOptionElem.selectedIndex;
    const initAuthURL = this.apiEndPoints.initAuthUrl;
    const JSEncrypt = new JSEncryptExports.JSEncrypt();
    JSEncrypt.setPublicKey(publicKey);
    const oid = _.trim(document.getElementById(OID_INPUT_ID).value);
    this.jsEncrypt = JSEncrypt;
    const encryptedOid = this.jsEncrypt.encrypt(oid);
    this.displayMessage('');
    const onlineIdField = document.getElementById(OID_INPUT_ID);
    const onlineIdValue = onlineIdField.value.trim();
    const isOnlineIDHidden = document.getElementById('inputOnlineId').classList.contains('hidden');
    const useAnotherIdFlag = document.getElementById('anotherOnlineIDFlag').value;

    // save Oid-val
    let OnlineIDSaved = 'false';
    if (document.getElementById('saveOnlineId').checked === true) {
      OnlineIDSaved = 'true';
    }
    if (!isOnlineIDHidden && !onlineIdValue) {
      this.displayMessage(this.jcr.onlineIdErrorMsg, 'alert');
    }
    let inputJson = {
      tokenSets: [{
        value: selectedIDIndex,
        type: "OID_INDEX"
      }],
      processRules: [{
        value: "OnlineIDPwd",
        name: "AuthenticationContext"
      }, {
        value: iaValue,
        name: "_ia"
      }, {
        value: OnlineIDSaved,
        name: "SAVE_ONLINE_ID"
      }],
      filterRules: [{
        value: "FlagScape",
        name: "CLIENT"
      }, {
        value: "WEB",
        name: "SOURCE"
      }]
    };
    if (!selectedID || useAnotherIdFlag === "Y") {
      inputJson.tokenSets[0].value = encryptedOid;
      inputJson.tokenSets[0].type = "ONLINE_ID";
    }
    const ajaxOptions = {
      method: 'POST',
      data: JSON.stringify(inputJson),
      url: initAuthURL,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      dataType: 'json',
      headers: {
        'content-type': 'application/json',
        clientAIT: '41339',
        accept: 'application/json',
        'cache-control': 'no-cache'
      }
    };
    ahTransportUtility._serviceCall(ajaxOptions, response => {
      const data = response.responseData;
      if (data && data.errorCode && data.errorCode === 'E0001' || data && data.errorCode && data.errorCode === 'GENERAL_AUTH_ERROR' || data && data.Completion.value && data.Completion.value === 'DENY') {
        polling = false;
        diDenyMessage = true;
        oidInput.classList.add('hidden');
        passCodeField.classList.add('hidden');
        saveOnlineId.classList.add('hidden');
        signIn.classList.add('hidden');
        signIn.parentElement.classList.add('hidden');
        forgotOidPwd.classList.add('hidden');
        signInWithMobileAppLink.classList.add('hidden');
        if (signInWithPwdlessLink) {
          signInWithPwdlessLink.classList.add('hidden');
        }
        dropDownElem.classList.add('hidden');
        signInWithMobileApp.classList.add('hidden');
        if (signInWithPwdless) {
          signInWithPwdless.classList.add('hidden');
        }
        signInWithPasscode.classList.add('hidden');
        signinWithPasscodeInstead.classList.remove('hidden');
        signInWithPasscodeWrapper.classList.add('hidden');
        signinWithPasscodeInsteadWrapper.classList.remove('hidden');
        mobileDeviceNotificationText.classList.add('hidden');
        mobileDeviceMaximumAttemptNotificationText.classList.remove('hidden');
        sendNotificationAgain.classList.add('hidden');
        sendNotificationAgainWrapper.classList.add('hidden');
        mobileDeviceGenericNotificationText.classList.add('hidden');
        enrollDiv.classList.add('hidden');
        securityHelp.classList.add('hidden');
        openAccount.classList.add('hidden');
        forgotOidPwd.classList.add('displayNone');
        signoutErrorMessage.classList.add('hidden');
      } else if (data && data.Completion.value && data.Completion.value === 'SUCCESS') {
        that._triggerPollingService();
      }
    });
  }
  handleSigninWithMobileAppClick(e) {
    polling = true;
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    document.getElementById('signin-message');
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
    const useAnotherIdFlag = document.getElementById('anotherOnlineIDFlag').value;
    if (e) {
      e.preventDefault();
    }
    if (this.ahPwdlessCommons._checkpwdlessEligibility(OID_SELECT_ID)) {
      this._handleRoute('dipollingRoute');
    }
    ahHpSignInModuleJS.submitLoader('show', 'signin-with-mobile-app-button');
    if (!selectedID || useAnotherIdFlag === "Y") {
      const caWidgetLoadURL = this.apiEndPoints.caWidgetLoadEntryUrl;
      const inputJson = {
        authenticationIdentifier: {},
        filterRules: {
          SOURCE: this.params.SOURCE,
          USECASE: this.params.USECASE,
          LOB: this.params.LOB,
          CLIENT: this.params.CLIENT,
          CHANNEL: this.params.CHANNEL
        }
      };
      const ajaxOptions = {
        method: 'POST',
        data: JSON.stringify(inputJson),
        url: caWidgetLoadURL,
        crossDomain: true,
        cache: false,
        timeout: 60000,
        processData: false,
        xhrFields: {
          withCredentials: true
        },
        dataType: 'json',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          'cache-control': 'no-cache'
        }
      };
      ahTransportUtility._serviceCall(ajaxOptions, response => {
        const data = response.responseData;
        if (data && data.status && data.status === 'SUCCESS') {
          publicKey = data.publicKey;
          this._triggerInitAuthService();
        }
      });
    } else {
      this._triggerInitAuthService();
    }
  }
  _triggerXHR(url, payload, successCallBack, errorCallBack, flowName) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('accept', 'application/json');
    xhr.setRequestHeader('cache-control', 'no-cache');
    xhr.onload = function () {
      if (xhr.status === 200) {
        let userInfo = JSON.parse(xhr.responseText);
        if (userInfo && !ahHpSignInModuleJS.isEmpty(userInfo)) {
          successCallBack(userInfo);
        } else {
          let errorText = JSON.parse(xhr.responseText);
          errorCallBack(errorText, flowName);
        }
      } else {
        let errorText = JSON.parse(xhr.responseText);
        errorCallBack(errorText, flowName);
      }
    };
    xhr.onloadend = function () {
      if (xhr.status == 404) self._handleRoute("pwdlessErrorRoute");
    };
    xhr.send(JSON.stringify(payload));
  }
  _constructPayload(callName) {
    let payload = {};

    // save Oid-val
    let OnlineIDSaved = 'false';
    if (document.getElementById('saveOnlineId').checked === true) {
      OnlineIDSaved = 'true';
    }
    if (callName === 'initauthWH') {
      payload = {
        "onlineIdIndex": 'TO_BE_FILLED',
        "optionsRequest": {
          "username": 'TO_BE_FILLED',
          "authenticatorSelection": {
            "requireResidentKey": false,
            "userVerification": "discouraged"
          },
          "extensions": {}
        },
        "filterRules": [{
          "value": "HomePage",
          "name": "USECASE"
        }, {
          "value": "WEBAUTH",
          "name": "FLOW"
        }, {
          "value": "BOA",
          "name": "CLIENT"
        }]
      };
    } else if (callName === 'verifyAuthWH') {
      payload = {
        "tokenSets": [{
          "value": "TO_BE_FILLED",
          "type": "ASSERTION"
        }, {
          "value": "TO_BE_FILLED",
          "type": "OID_INDEX"
        }],
        "processRules": [{
          "value": "WebAuth",
          "name": "AuthenticationContext"
        }, {
          "value": OnlineIDSaved,
          "name": "SAVE_ONLINE_ID"
        }, {
          "value": "true",
          "name": "U2F_SUPPORTED_BROWSER"
        }, {
          "value": "",
          "name": "_dr"
        }],
        "filterRules": [{
          "value": "WEB",
          "name": "CHANNEL"
        }, {
          "value": "DIGITAL-SALES",
          "name": "LOB"
        }, {
          "value": "HOMEPAGE",
          "name": "USECASE"
        }, {
          "value": "WEBAUTH",
          "name": "FLOW"
        }, {
          "value": "BOA",
          "name": "CLIENT"
        }]
      };
    }
    return payload;
  }

  /**
    * @function _GlobalVariable
    * @description setting global variable
    * @returns {void}
    */
  _GlobalVariable() {
    const securityHelp = this.settings.target.querySelector('#security');
    const enroll = this.settings.target.querySelector('#enroll');
    const GLOBAL_SELECTORS = {
      signinPwdlessButton: this.settings.target.querySelector('#' + SIGNIN_WITH_PWDLESS),
      signInWithPasscodeWrapper: this.settings.target.querySelector('#signin-with-passcode-wrapper'),
      signinContainer: this.settings.target.querySelector('#skip_to_signin'),
      PwdlessFailed: this.settings.target.querySelector('#PwdlessFailedNotification'),
      tryAgainPwdless: this.settings.target.querySelector('#' + TRY_AGAIN_PWDLESS_WH),
      tryAgainPwdlessLoader: this.settings.target.querySelector('#try-again-loader-wh'),
      pwdlessLoaderWh: this.settings.target.querySelector('#pwdless-loader-wh'),
      pwdlessSignInWithMobileAppLink: this.settings.target.querySelector('#pwdlessSignInWithMobileAppLink'),
      signInWithPasscode: this.settings.target.querySelector('#' + SIGNIN_WITH_PASSCODE_INSTEAD),
      signInPwdlessLink: this.settings.target.querySelector('#' + SIGNIN_WITH_PWDLESS_LINK),
      PwdlessTempNotification: this.settings.target.querySelector('#PwdlessTempNotification'),
      PwdlessCurrentNotification: this.settings.target.querySelector('#PwdlessCurrentNotification'),
      mainforgotLink: this.settings.target.querySelector('#forgot-links'),
      securityHelp: securityHelp,
      enroll: enroll,
      securityHelpParent: securityHelp.parentNode,
      enrollParent: enroll.parentNode,
      forgotOidPwd: this.settings.target.querySelector('#forgot-oid-pwd'),
      pwdlessSignInWithPasscodeInstead: this.settings.target.querySelector('#' + PWDLESS_SIGNIN_WITH_PASSCODE_INSTEAD),
      tempSigninWithPasscodeInstead: this.settings.target.querySelector('#temp-signin-with-passcode-instead'),
      signInWithMobileAppLink: this.settings.target.querySelector('#signInWithMobileAppLink'),
      currentSigninWithPasscodeInstead: this.settings.target.querySelector('#current-signin-with-passcode-instead')
    };
    return GLOBAL_SELECTORS;
  }
  _classHideList(selectorList) {
    if (selectorList && Array.isArray(selectorList) && selectorList.length > 0) {
      selectorList.forEach((selector, index) => {
        if (selector && selector.classList) {
          selector.classList.add('hidden');
        } else {
          if (selector) {
            selector.setAttribute('class', 'hidden');
          }
        }
      });
    }
  }
  _classShowList(selectorList) {
    if (selectorList && Array.isArray(selectorList) && selectorList.length > 0) {
      selectorList.forEach((selector, index) => {
        if (selector && selector.classList) {
          selector.classList.remove('hidden');
        }
      });
    }
  }
  _handlePwdlessError(data, flowName) {
    const self = this;
    let targetScreen = flowName;
    self._togglePwdlessLoader();
    if (data.responseError === "E22122") {
      targetScreen = "pwdlessTempOffRoute";
    } else if (data.responseError === 'E0001') {
      targetScreen = "pwdlessDenyRoute";
    }
    self._handleRoute(targetScreen);
  }
  _handleRoute(screenName) {
    const self = this;
    let showList = [];
    let hideList = [];
    let GLOBAL_SELECTORS = self._GlobalVariable();
    self._togglePwdlessLoader("reset");
    ahHpSignInModuleJS.submitLoader('hide', 'signin-pwdless-button');
    if (screenName === 'pwdlessErrorRoute') {
      showList = [GLOBAL_SELECTORS.pwdlessSignInWithPasscodeInstead, GLOBAL_SELECTORS.PwdlessFailed, GLOBAL_SELECTORS.tryAgainPwdless];
      hideList = [GLOBAL_SELECTORS.signInWithPasscodeWrapper, GLOBAL_SELECTORS.signinContainer, GLOBAL_SELECTORS.signInPwdlessLink];
      if (self.isDigitalUser()) {
        showList.push(GLOBAL_SELECTORS.pwdlessSignInWithMobileAppLink);
        hideList.push(GLOBAL_SELECTORS.signInWithMobileAppLink);
      } else {
        hideList.push(GLOBAL_SELECTORS.signInWithMobileAppLink);
        hideList.push(GLOBAL_SELECTORS.pwdlessSignInWithMobileAppLink);
      }
      if (errorCountPwdless === 4) {
        hideList.push(GLOBAL_SELECTORS.tryAgainPwdless);
      }
    } else if (screenName === 'signinWithPasscodeRoute') {
      showList = [GLOBAL_SELECTORS.signinContainer, GLOBAL_SELECTORS.forgotOidPwd, GLOBAL_SELECTORS.securityHelpParent, GLOBAL_SELECTORS.securityHelp, GLOBAL_SELECTORS.enroll, GLOBAL_SELECTORS.enrollParent];
      hideList = [GLOBAL_SELECTORS.signInWithPasscodeWrapper, GLOBAL_SELECTORS.PwdlessTempNotification, GLOBAL_SELECTORS.PwdlessCurrentNotification, GLOBAL_SELECTORS.currentSigninWithPasscodeInstead, GLOBAL_SELECTORS.PwdlessFailed];
      if (self.ahPwdlessCommons._checkpwdlessEligibility(OID_SELECT_ID)) {
        showList.push(GLOBAL_SELECTORS.signInPwdlessLink);
      }
      if (this.isDigitalUser()) {
        showList.push(GLOBAL_SELECTORS.signInWithMobileAppLink);
      }
    } else if (screenName === 'pwdlessTempOffRoute') {
      showList = [GLOBAL_SELECTORS.PwdlessTempNotification, GLOBAL_SELECTORS.tempSigninWithPasscodeInstead];
      hideList = [GLOBAL_SELECTORS.signInPwdlessLink, GLOBAL_SELECTORS.PwdlessCurrentNotification, GLOBAL_SELECTORS.currentSigninWithPasscodeInstead, GLOBAL_SELECTORS.signInWithPasscodeWrapper, GLOBAL_SELECTORS.signinContainer, GLOBAL_SELECTORS.forgotOidPwd, GLOBAL_SELECTORS.securityHelpParent, GLOBAL_SELECTORS.securityHelp, GLOBAL_SELECTORS.enroll, GLOBAL_SELECTORS.enrollParent, GLOBAL_SELECTORS.signInWithMobileAppLink];
    } else if (screenName === 'pwdlessDenyRoute') {
      showList = [GLOBAL_SELECTORS.PwdlessCurrentNotification, GLOBAL_SELECTORS.currentSigninWithPasscodeInstead];
      hideList = [GLOBAL_SELECTORS.signInPwdlessLink, GLOBAL_SELECTORS.PwdlessTempNotification, GLOBAL_SELECTORS.tempSigninWithPasscodeInstead, GLOBAL_SELECTORS.signInWithPasscodeWrapper, GLOBAL_SELECTORS.signinContainer, GLOBAL_SELECTORS.forgotOidPwd, GLOBAL_SELECTORS.securityHelpParent, GLOBAL_SELECTORS.securityHelp, GLOBAL_SELECTORS.enroll, GLOBAL_SELECTORS.enrollParent, GLOBAL_SELECTORS.signInWithMobileAppLink];
    } else if (screenName === 'dipollingRoute') {
      hideList = [GLOBAL_SELECTORS.signInPwdlessLink, GLOBAL_SELECTORS.signinPwdlessButton, GLOBAL_SELECTORS.PwdlessFailed, GLOBAL_SELECTORS.PwdlessCurrentNotification, GLOBAL_SELECTORS.currentSigninWithPasscodeInstead, GLOBAL_SELECTORS.PwdlessTempNotification, GLOBAL_SELECTORS.tempSigninWithPasscodeInstead];
    }
    self._classShowList(showList);
    self._classHideList(hideList);
  }
  handleInitAuth(data) {
    const self = this;
    let publicKey = self.ahPwdlessCommons._preformatGetAssertReq(data.optionsResponse);
    if (navigator && navigator.credentials) {
      navigator.credentials.get({
        publicKey
      }).then(CredentialInfo => {
        self._triggerVerifyAuthWH(CredentialInfo);
      }).catch(error => {
        self._togglePwdlessLoader();
        self._handleRoute("pwdlessErrorRoute");
      });
    } else {
      self._handleRoute("pwdlessErrorRoute");
    }
  }

  /**
  * @function handleSigninwithPwdLess
  * @description handling signin with passwordless
  * @returns {void}
  */
  handleSigninwithPwdLess() {
    const self = this;
    //self._handleRoute("pwdlessTempOff");
    const initAuthURL = this.apiEndPoints.initAuthPwdLess;
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
    const selectedIndex = dropDownOptionElem.selectedIndex;
    let deafultPayload = self._constructPayload('initauthWH');
    deafultPayload.onlineIdIndex = selectedIndex;
    deafultPayload.optionsRequest.username = selectedID;
    ahHpSignInModuleJS.submitLoader('show', 'signin-pwdless-button');
    this._triggerXHR(initAuthURL, deafultPayload, self.handleInitAuth, self._handlePwdlessError, 'pwdlessErrorRoute');
  }

  /**
  * @function handleSigninwithPwdLessTA
  * @description handling signin with passwordlessTA
  * @returns {void}
  */
  handleSigninwithPwdLessTA() {
    const self = this;
    if (self._errorCountPwdless()) {
      self._togglePwdlessLoader();
      self.handleSigninwithPwdLess();
    }
  }

  /**
  * @function _errorCountPwdless
  * @description handling error count passwordless
  * @returns {void}
  */
  _errorCountPwdless() {
    const self = this;
    self._GlobalVariable();
    errorCountPwdless = errorCountPwdless + 1;
    if (errorCountPwdless > 4) {
      return false;
    } else {
      return true;
    }
  }

  /**
  * @function _togglePwdlessLoader
  * @description handling toggle passwordless loader
  * @returns {void}
  */
  _togglePwdlessLoader(forceSet) {
    const self = this;
    let hideList,
      showList = [];
    let GLOBAL_SELECTORS = self._GlobalVariable();
    if (GLOBAL_SELECTORS.tryAgainPwdless.classList.contains('hidden') || forceSet && forceSet === 'reset') {
      showList = [GLOBAL_SELECTORS.tryAgainPwdless];
      hideList = [GLOBAL_SELECTORS.tryAgainPwdlessLoader];
    } else {
      hideList = [GLOBAL_SELECTORS.tryAgainPwdless];
      showList = [GLOBAL_SELECTORS.tryAgainPwdlessLoader];
    }
    self._classHideList(hideList);
    self._classShowList(showList);
  }
  _triggerVerifyAuthWH(CredentialInfo) {
    console.log('Trigger VerifyAuth - END');
    const self = this;
    let requestPayload = self.ahPwdlessCommons._publicKeyCredentialToJSON(CredentialInfo);
    let deafultPayload = self._constructPayload('verifyAuthWH');
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    const selectedIndex = dropDownOptionElem.selectedIndex;
    let stringifiedPayload = JSON.stringify(requestPayload);
    //converstion of the framework payload to base64 encoded payload.
    let encodedPayload = window.btoa(stringifiedPayload);
    deafultPayload.tokenSets[0].value = encodedPayload;
    deafultPayload.tokenSets[1].value = selectedIndex;
    let VerifyAuthURLWH = this.apiEndPoints.VerifyAuthURLWH;
    this._triggerXHR(VerifyAuthURLWH, deafultPayload, self.handleVerifyAuth, self._handlePwdlessError, 'pwdlessErrorRoute');
  }
  handleVerifyAuth(response) {
    const self = this;
    ahHpSignInModuleJS.submitLoader('hide', 'signin-pwdless-button');
    self._togglePwdlessLoader();
    if (response.Completion && response.Completion.value === 'ALLOW') {
      self._triggerPostAuthService();
    } else if (response.Completion && response.Completion.value === 'CHALLENGE') {
      //get verifyAuth payload and store in cookie
      self.SpartaFunctions.spartaSetCookie('windowHelloData', JSON.stringify(response), false, true);
      let stepupRDUrl = this.apiEndPoints.OLBStepupRedirect;
      if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'es-US') {
        window.location.replace(stepupRDUrl + '/es');
      } else {
        window.location.replace(stepupRDUrl);
      }
    }
  }

  /**
  * @function handleSigninwithPasscodeClick
  * @description handling signin with passcode click
  * @returns {void}
  */
  handleSigninwithPasscodeClick() {
    polling = false;
    const useAnotherFlag = document.getElementById('anotherOnlineIDFlag').value;
    const oidInput = this.settings.target.querySelector('#inputOnlineId');
    const oidInputText = this.settings.target.querySelector('#onlineId1');
    const saveOnlineId = this.settings.target.querySelector('#saveOnlineIdCheckBox');
    const signInWithMobileApp = this.settings.target.querySelector('#signin-with-mobile-app');
    const signInWithPwdless = this.settings.target.querySelector('#signin-pwdless');
    const passCodeFieldInput = this.settings.target.querySelector('#passcode1');
    const passCodeField = passCodeFieldInput.parentNode.parentNode;
    const dropDownElem = this.settings.target.querySelector('#dropDown');
    const signIn = this.settings.target.querySelector('#signIn');
    const securityHelp = this.settings.target.querySelector('#security');
    securityHelp.parentNode;
    const enroll = this.settings.target.querySelector('#enroll');
    const enrollDiv = enroll.parentNode;
    const open = this.settings.target.querySelector('#open');
    const openAccount = open.parentNode;
    const forgotOidPwd = this.settings.target.querySelector('#forgot-oid-pwd');
    const forgotOidPwdParent = forgotOidPwd.parentNode;
    forgotOidPwd.firstElementChild;
    const signInWithMobileAppLink = this.settings.target.querySelector('#signInWithMobileAppLink');
    this.settings.target.querySelector('#signin-pwdless-link');
    const signInWithMobileAppLinkPilot = this.settings.target.querySelector('#signin-with-mobile-app-link');
    const signInWithPasscode = this.settings.target.querySelector('#signin-with-passcode');
    const signInWithPasscodeWrapper = this.settings.target.querySelector('#signin-with-passcode-wrapper');
    const mobileDeviceNotificationText = this.settings.target.querySelector('#mobileDeviceNotificationText');
    const mobileDeviceGenericNotificationText = this.settings.target.querySelector('#mobileDeviceGenericNotificationText');
    const mobileDeviceMaximumAttemptNotificationText = this.settings.target.querySelector('#mobileDeviceMaximumAttemptNotificationText');
    const sendNotificationAgain = this.settings.target.querySelector('#send-notification-again');
    const sendNotificationAgainWrapper = this.settings.target.querySelector('#send-notification-again-wrapper');
    const signinWithPasscodeInstead = this.settings.target.querySelector('#signin-with-passcode-instead');
    const signinWithPasscodeInsteadWrapper = this.settings.target.querySelector('#signin-with-passcode-instead-wrapper');
    const olbSigninPrefillMultiSecureCookie = this.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
    this.SpartaFunctions.spartaGetCookie('pwdl').trim();
    const onlineIdList = olbSigninPrefillMultiSecureCookie.split('||');
    const dropDownOptionElem = document.getElementById(OID_SELECT_ID);
    document.getElementById(OID_INPUT_ID);
    const selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].value;
    for (let i = 0; i < onlineIdList.length; i++) {
      onlineIdList[i].split(':');
      if (onlineIdList[i].indexOf(selectedID) > -1) {
        onlineIdList[i].split(':')[1];
      }
    }
    if (selectedID) {
      if (!diDenyMessage) {
        if (this.jcr.switch.enableDI === "true") {
          signInWithMobileAppLink.classList.remove('hidden');
          signInWithMobileAppLinkPilot.classList.remove('hidden');
        }
      }
      if (useAnotherFlag === "Y") {
        oidInput.classList.remove('hidden');
        dropDownElem.classList.add('hidden');
      } else {
        oidInput.classList.add('hidden');
        dropDownElem.classList.remove('hidden');
      }
      saveOnlineId.classList.add('hidden');
    } else {
      oidInput.classList.remove('hidden');
      dropDownElem.classList.add('hidden');
      if (diDenyMessage) {
        signInWithMobileAppLink.classList.add('hidden');
        signInWithMobileAppLinkPilot.classList.add('hidden');
      }
      saveOnlineId.classList.remove('hidden');
    }
    passCodeField.classList.remove('hidden');
    passCodeFieldInput.value = "";
    signIn.classList.remove('hidden');
    signIn.parentElement.classList.remove('hidden');
    forgotOidPwd.classList.remove('hidden');
    signInWithMobileApp.classList.add('hidden');
    signInWithPwdless.classList.add('hidden');
    signInWithPasscode.classList.add('hidden');
    signInWithPasscodeWrapper.classList.add('hidden');
    signinWithPasscodeInstead.classList.add('hidden');
    signinWithPasscodeInsteadWrapper.classList.add('hidden');
    mobileDeviceNotificationText.classList.add('hidden');
    sendNotificationAgain.classList.add('hidden');
    sendNotificationAgainWrapper.classList.add('hidden');
    mobileDeviceNotificationText.classList.add('hidden');
    mobileDeviceGenericNotificationText.classList.add('hidden');
    mobileDeviceMaximumAttemptNotificationText.classList.add('hidden');
    enrollDiv.classList.remove('hidden');
    securityHelp.classList.add('hidden');
    openAccount.classList.remove('hidden');
    forgotOidPwdParent.appendChild(forgotOidPwd);
    if (this.settings.target.querySelector('.horizontalPartial')) {
      document.getElementsByClassName('separator')[0].classList.remove('hidden');
      document.getElementsByClassName('separator')[1].classList.remove('hidden');
    }
    oidInputText.value = "";

    /**Code for checking webbio eligibility and manipulate DOM Accordingly */

    this._handleRoute('signinWithPasscodeRoute');
  }

  /**
   * 
   * @description Is empty function
   */

  static isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  /**
   * @function handleSendNotificationAgain
   * @description handling send notification again
   * returns {void}
   */
  handleSendNotificationAgain() {
    const that = this;
    that._triggerInitAuthService();
  }
  /**
   * @description Delegate event listeners to the module container so dom re-rendering will not double bind etc.
   *
   * @param {String} event - event to listen for
   * @param {String} selector - selector to delegate to target
   * @param {Function} handler - handler for event being listened for
   * @returns {void}
   */
  delegateEvent(event, selector, handler) {
    this.settings.target.addEventListener(event, function delegateTarget(e) {
      for (let target = e.target; target && target !== this; target = target.parentNode) {
        if (target.matches(selector)) {
          handler.call(target, e);
          break;
        }
      }
    }, false);
  }

  /**
   * @description submit loader - show and hide the loader
   *
   * @param {string} [state='show'] - state of the submitButton
   * @static
   * @returns {void}
   */
  static submitLoader(state = 'show', id = 'signIn') {
    const submitButton = document.getElementById(id);
    if (state === 'show') {
      submitButton.classList.add('loading');
    } else {
      submitButton.classList.remove('loading');
    }
  }

  /**
   * @description Focus online id field
   *
   * @static
   * @returns {void}
   */
  static focusOnlineIdField() {
    setTimeout(() => {
      const oidInput = document.getElementById(OID_INPUT_ID);
      const disableOidFocus = document.activeElement === oidInput;
      const disableAutoFocus = document.activeElement === document.getElementById(PASSCODE_INPUT_ID);
      const oidPasscode = document.getElementById(PASSCODE_INPUT_ID);
      oidPasscode.value = '';
      if (!disableOidFocus && !disableOidFocus && !disableAutoFocus && oidInput) {
        oidInput.value = '';
        oidInput.focus();
      }
    }, 2e3);
  }

  /**
   * @description Focus passcode field
   *
   * @static
   * @returns {void}
   */
  static focusPasscodeField() {
    setTimeout(() => {
      // Safari fix - check to see if the multi user form is focused. If it is - don't focus pass.
      if (document.activeElement && document.activeElement.id === OID_SELECT_ID) return;
      document.getElementById(PASSCODE_INPUT_ID).focus();
    }, 2e3);
  }

  /**
   * @description Focus the medium sign in close - only for medium login
   *
   * @static
   * @returns {void}
   */
  static focusMediumSignInClose() {
    if (spartaMediaQueryUtility.getCurrentViewport().currentViewport === 'medium') {
      document.getElementById('LOGIN_MEDIUM').focus();
    }
  }
}
registerModuleClass({
  moduleClass: ahHpSignInModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ahHpSignInModuleJS as default, moduleConfig };
